export default "__VITE_ASSET__DGsw7OQT__"